// @ts-nocheck
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import LoginReducer from './features/login/reducer';
import ChangelogReducer from './reducers/ChangelogReducer';
import CommonReducer from './reducers/CommonReducer';
import FilterReducer from './reducers/FilterReducer';
import objectTreeReducer from './reducers/objectTreeReducer';
import PDCReducer from './reducers/PDCReducer';
import ProductActivationReducer from './reducers/ProductActivationReducer';
import UIStateReducer from './reducers/UIStateReducer';
import { runSagas } from './sagas';

export const logStoreChange = (injectedConsole, action, state, noTestRun) => {
    if (noTestRun) {
        injectedConsole.group(action.type);
        injectedConsole.info('dispatching', action);
        injectedConsole.log('state', state);
        injectedConsole.groupEnd(action.type);
    }
};

export const rootReducer = combineReducers({
    common: CommonReducer,
    pdc: PDCReducer,
    productActivation: ProductActivationReducer,
    uiState: UIStateReducer,
    login: LoginReducer,
    changelog: ChangelogReducer,
    filters: FilterReducer,
    objectTree: objectTreeReducer,
});

export const getStore = preloadedState => {
    const logger = createLogger();
    const sagaMiddleware = createSagaMiddleware();
    const store = configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false,
            }).concat(sagaMiddleware, logger),
    });

    runSagas(sagaMiddleware);

    store.dispatch({
        payload: {
            navigation: 'TREETYPE_DRIVER',
        },
        type: 'forest/FILTER',
    });

    return store;
};

const store = getStore();

export type RootState = ReturnType<typeof rootReducer>;
export type RootStore = ReturnType<typeof getStore>;
export type AppDispatch = RootStore['dispatch'];

export default store;
